import { combineReducers } from "redux"
import authReducer from "./features/auth/authSlice.js"

export const rootReducer = combineReducers({
  auth: authReducer,
})
